import React, { Component } from 'react';
import { Toast, SearchBar, Icon } from 'antd-mobile';
import PropTypes from 'prop-types';
import { getShoppingRoomLive } from '../../service/chat-service';
import styles from './styles.module.less';
import time from '../../public/images/time.png';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const defaultProps = {};
class liveList extends Component {
  end = false

  constructor(props) {
    super(props);
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const companyCode = new URLSearchParams(windowHref).get('companyCode');
    const shareUserId = new URLSearchParams(windowHref).get('shareUserId');
    this.state = {
      shopList: [],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      companyCode,
      shareUserId,
    };
  }

  componentDidMount() {
    document.title = '直播列表';
    this.loadData();
    this.addScrollEvent();
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  loadData = async (pageNum2) => {
    const { pageNum, companyCode } = this.state;
    const pageNum1 = pageNum2 || pageNum;
    const { pageSize, shopList } = this.state;
    const obj = {
      companyCode,
      pageNum: pageNum1,
      pageSize,
    };

    if (this.end) return false;
    this.setState({ loading: true });

    try {
      const { data } = (await getShoppingRoomLive(obj)) || {};

      let orderList = shopList;
      if (Array.isArray(data) && data.length) {
        if (data.length < pageSize) this.end = true;
        orderList = shopList.concat(data);
      }
      this.setState({ shopList: orderList, pageNum: pageNum1, loading: false });
    } catch (e) {
      Toast.show(e.message);
      this.setState({ loading: false });
    }
    return true;
  }

  liveListRenderingOpen=(id) => {
    const { shareUserId } = this.state;
    const { history } = this.props;
    history.push(`/signUp?id=${id}&staffUserId=${shareUserId}`);
  }

// 直播活动列表渲染
liveListRendering=() => {
  const { shopList } = this.state;
  return shopList.map((item) => (
    <div
      key={item.livePicAddress}
      className={styles.shopPage}
      role="button"
      tabIndex={0}
      onClick={this.liveListRenderingOpen.bind(null, item.id)}
    >
      <div className={styles.shopPageL}>
        <img src={item.livePicAddress} alt="" />
      </div>
      <div className={styles.shopPageRs}>
        <div>
          <div>{item.liveName}</div>
        </div>
        <h6>{this.types(item.streamState)}</h6>
        <div>
          <span>
            <img src={time} alt="" />
          </span>
          <span>
            {item.expectedStartTime}
          </span>
        </div>
      </div>
    </div>
  ));
}

// 直播间状态：active：活跃，inactive：非活跃，forbid：禁播，end：直播结束
types =(e) => {
  let text = '';
  if (e === 'active') {
    text = '直播中';
  } if (e === 'inactive') {
    text = '未直播';
  } if (e === 'end') {
    text = '已结束';
  }
  return text;
}

  // 搜索
  searchValue=(value) => {
    const { companyCode } = this.state;
    const obj = {
      companyCode,
      name: value,
      pageNum: 1,
      pageSize: 10,
    };
    getShoppingRoomLive(obj).then((res) => {
      this.setState({ shopList: res.data });
    });
  }

  cancel=() => {
    this.getShoppingRoomLive();
  }

  scrollBottomLoad = () => {
    const { pageNum, loading } = this.state;
    if (this.end || loading) return false;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const bodyHeight = document.getElementById('order_content_H9').clientHeight;
    const { clientHeight } = document.documentElement;

    if (scrollTop + clientHeight === bodyHeight) {
      this.loadData(pageNum + 1);
    }
    return true;
  }

  addScrollEvent = () => {
    window.addEventListener('scroll', this.scrollBottomLoad);
  }

  removeScrollEvent = () => window.removeEventListener('scroll', this.scrollBottomLoad)

  render() {
    const { loading } = this.state;
    return (
      <div className={styles.orderContent} id="order_content_H9">
        <SearchBar placeholder="搜索关键词或标签" onSubmit={this.searchValue} onCancel={this.cancel} />
        {this.liveListRendering()}
        {loading && (
          <div className={styles.loading}>
            <Icon type="loading" />
          </div>
        )}
      </div>
    );
  }
}
liveList.propTypes = propTypes;
liveList.defaultProps = defaultProps;

export default liveList;
